/*Recurso: Configurations - Servicio de lectura del API: Maneja los elementos de Configuración
  Tareas:
    GetSummaryProponentUser               //lee los usuarios proponentes
    GetSummaryUserNotificationbyEmail     //lee los usuarios para notificaciones  
    UpdateProponentUser                   //guarda los usuarios proponentes
    UpdateUserNotificationbyEmail         //guarda los usuarios para notificaciones  
*/

import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL + 'Configurations/';

  //se genera una función por cada tarea del recurso api

    //tarea: GetSummaryProponentUser
    const cargaGetSummaryProponentUser = async (token:any) => {
      //console.log ('***API: ' + API_URL + 'GetSummaryProponentUser', {headers: { 'content-type': 'text/json' }} )
      return await axios.post(API_URL + 'GetSummaryProponentUser', 'method: post',
          {headers: { 'content-type': 'text/json', "Authorization":token }} )
    };

    //tarea: GetSummaryUserNotificationbyEmail
    const cargaGetSummaryUserNotificationbyEmail = async (token:any) => {
     // console.log ('***API: ' + API_URL + 'GetSummaryUserNotificationbyEmail', {headers: { 'content-type': 'text/json' }} )
      return await axios.post(API_URL + 'GetSummaryUserNotificationbyEmail', 'method: post',
          {headers: { 'content-type': 'text/json', "Authorization":token }} )
    };

    
    //tarea: UpdateProponentUser
    const cargaUpdateProponentUser = async (token:any, body:any) => {
      //console.log ('***API: ' + API_URL + 'UpdateProponentUser', body,  {headers: { 'content-type': 'text/json' }} )
      return await axios.post(API_URL + 'UpdateProponentUser', body, 
          {headers: { 'content-type': 'text/json', "Authorization":token }} )
    };

    //tarea: UpdateUserNotificationbyEmail
    const cargaUpdateUserNotificationbyEmail = async (token:any, body:any) => {
      //console.log ('***API: ' + API_URL + 'UpdateUserNotificationbyEmail', body,  {headers: { 'content-type': 'text/json' }} )
      return await axios.post(API_URL + 'UpdateUserNotificationbyEmail', body, 
          {headers: { 'content-type': 'text/json', "Authorization":token }} )
    };

const configurationsService = {
    cargaGetSummaryProponentUser: cargaGetSummaryProponentUser,
    cargaGetSummaryUserNotificationbyEmail: cargaGetSummaryUserNotificationbyEmail,
    cargaUpdateProponentUser: cargaUpdateProponentUser,
    cargaUpdateUserNotificationbyEmail: cargaUpdateUserNotificationbyEmail,
};

export default configurationsService;
